export default __webpack_public_path__ + "static/media/frilagds_pckassa.8e87136f.png";